/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types"
import FormWrapper from "components/FormWrapper";
import { Button } from "components/Buttons";
import { Input, TextArea } from "components/Inputs";
import FormTitle from "components/FormTitle";
import FormCaption from "components/FormCaption";
import PermissionCard from "./PermissionCard";
import SelectPermissions from "./SelectPermissions";
import Modal from "components/Modal";
import useSettings from "hooks/fetch/useSettings";
import { useSelector } from "react-redux";
import Spinner from "components/Spinner";

export default function CreateRole({ skip }) {
    const { create_roles, loading } = useSettings()
    const { get_roles, loading: loadingRoles } = useSettings()
    const { roles } = useSelector(state => state.settings)
    const [showModal, setShowModal] = useState(false)
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        permissions: []
    })

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const setPermissions = (permissions) => {
        setFormData({ ...formData, permissions })
        setShowModal(!showModal)
    }

    const submit = () => {
        create_roles(formData, () => skip())
    }

    useEffect(() => {
        get_roles()
    },[])

    return (
        <FormWrapper
            key={0}
            onSubmit={submit}
        >
            <>
                <div className="max-w-[414px] mx-auto mb-[24px]">
                    <div>
                        <div className="w-full sm:max-w-[255px] sm:mx-auto sm:text-center">
                            <div className="flex justify-between sm:justify-center">
                                <FormTitle title="Create Roles" className="text-24" />
                                <Button
                                    name="Skip"
                                    theme="transparent"
                                    width="w-[54px]"
                                    size="small"
                                    type="button"
                                    className="sm:hidden"
                                    disabled={loading}
                                    onClick={skip}
                                />
                            </div>
                            <FormCaption caption="Lorem ipsum dolor sit amet consectetur molesti" className="text-14" />
                        </div>
                        <div className="mb-[24px]">
                            <Input
                                label="Role Name"
                                type="text"
                                id="name"
                                name="name"
                                readOnly={loading}
                                value={formData?.name}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="mb-[26.5px]">
                            <TextArea
                                label="Description"
                                type="text"
                                id="description"
                                name="description"
                                readOnly={loading}
                                value={formData?.description}
                                onChange={handleChange}
                                rows={6}
                                maxLength="250"
                            />
                            <p className="text-12 text-[#000000] font-campton_r">{formData?.description?.length}/250</p>
                        </div>
                        <div className="flex justify-center">
                            <Button
                                name="Select Permissions for this role"
                                theme="light_orange"
                                width="w-[231px]"
                                size="small"
                                type="button"
                                disabled={loading}
                                onClick={() => setShowModal(true)}
                            />
                        </div>
                    </div>
                </div>
                <div className="w-full border-dashed border-t border-t-neutral_stroke_1 pt-[40px]">
                    {
                        !roles?.length && !loadingRoles ?
                            <div className="flex flex-col items-center mb-[40px]">
                                <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-[16px]">
                                    <rect x="0.5" width="40" height="40" rx="20" fill="#F7FBFD" />
                                    <path d="M15.5491 26.6C15.6279 26.6592 15.7176 26.7024 15.8131 26.7269C15.9086 26.7514 16.008 26.7569 16.1056 26.7429C16.2032 26.729 16.2972 26.696 16.382 26.6457C16.4668 26.5954 16.5409 26.5289 16.6 26.45C17.0541 25.8445 17.6429 25.3531 18.3198 25.0147C18.9968 24.6762 19.7432 24.5 20.5 24.5C21.2568 24.5 22.0032 24.6762 22.6802 25.0147C23.3571 25.3531 23.9459 25.8445 24.4 26.45C24.4591 26.5288 24.5331 26.5952 24.6179 26.6454C24.7026 26.6955 24.7964 26.7285 24.8939 26.7425C24.9914 26.7564 25.0907 26.751 25.1861 26.7265C25.2815 26.7021 25.3712 26.6591 25.45 26.6C25.5288 26.5409 25.5952 26.4669 25.6454 26.3821C25.6955 26.2974 25.7285 26.2036 25.7425 26.1061C25.7564 26.0086 25.751 25.9093 25.7265 25.8139C25.7021 25.7185 25.6591 25.6288 25.6 25.55C24.9359 24.6596 24.0503 23.9586 23.0312 23.5166C23.5897 23.0067 23.981 22.3399 24.1537 21.6037C24.3264 20.8675 24.2725 20.0962 23.9991 19.3912C23.7256 18.6862 23.2454 18.0803 22.6215 17.653C21.9976 17.2258 21.259 16.9972 20.5028 16.9972C19.7466 16.9972 19.0081 17.2258 18.3841 17.653C17.7602 18.0803 17.28 18.6862 17.0065 19.3912C16.7331 20.0962 16.6792 20.8675 16.8519 21.6037C17.0247 22.3399 17.4159 23.0067 17.9744 23.5166C16.9533 23.9577 16.0657 24.6588 15.4 25.55C15.2806 25.709 15.2292 25.909 15.2571 26.1059C15.2851 26.3028 15.3901 26.4805 15.5491 26.6ZM20.5 18.5C20.945 18.5 21.38 18.632 21.75 18.8792C22.12 19.1264 22.4084 19.4778 22.5787 19.889C22.749 20.3001 22.7936 20.7525 22.7068 21.189C22.62 21.6254 22.4057 22.0263 22.091 22.341C21.7763 22.6557 21.3754 22.87 20.939 22.9568C20.5025 23.0436 20.0501 22.999 19.639 22.8287C19.2278 22.6584 18.8764 22.37 18.6292 22C18.382 21.63 18.25 21.195 18.25 20.75C18.25 20.1533 18.4871 19.581 18.909 19.159C19.331 18.7371 19.9033 18.5 20.5 18.5ZM27.25 10.25H13.75C13.3522 10.25 12.9706 10.408 12.6893 10.6893C12.408 10.9706 12.25 11.3522 12.25 11.75V28.25C12.25 28.6478 12.408 29.0294 12.6893 29.3107C12.9706 29.592 13.3522 29.75 13.75 29.75H27.25C27.6478 29.75 28.0294 29.592 28.3107 29.3107C28.592 29.0294 28.75 28.6478 28.75 28.25V11.75C28.75 11.3522 28.592 10.9706 28.3107 10.6893C28.0294 10.408 27.6478 10.25 27.25 10.25ZM27.25 28.25H13.75V11.75H27.25V28.25ZM16.75 14C16.75 13.8011 16.829 13.6103 16.9697 13.4697C17.1103 13.329 17.3011 13.25 17.5 13.25H23.5C23.6989 13.25 23.8897 13.329 24.0303 13.4697C24.171 13.6103 24.25 13.8011 24.25 14C24.25 14.1989 24.171 14.3897 24.0303 14.5303C23.8897 14.671 23.6989 14.75 23.5 14.75H17.5C17.3011 14.75 17.1103 14.671 16.9697 14.5303C16.829 14.3897 16.75 14.1989 16.75 14Z" fill="#205F74" />
                                </svg>
                                <p className="text-16 font-campton_m text-neutral_black">No role created</p>
                                <p className="text-14 font-campton_r text-neutral_body">Role created will be displayed here</p>
                            </div> : ''
                    }
                    {loadingRoles ? <Spinner/> : ''}
                    <div className="mb-[40px] flex overflow-x-auto">
                        {
                            !loadingRoles && roles?.map((role) =>
                                <PermissionCard
                                    key={role._id}
                                    role={role}
                                    className="mr-[16px] shrink-0"
                                />
                            )
                        }
                    </div>
                    <div className="flex justify-between items-center w-full">
                        <Button
                            name="Save & Continue"
                            theme="blue"
                            width="w-full sm:w-[153px]"
                            disabled={!formData.name || !formData.description || !formData.permissions?.length || loading}
                            loading={loading}
                        />
                        <Button
                            name="Skip"
                            theme="transparent"
                            width="w-[54px]"
                            size="small"
                            type="button"
                            className="hidden sm:block"
                            disabled={loading}
                            onClick={skip}
                        />
                    </div>
                </div>
                {
                    showModal &&
                    <Modal
                        closeModal={() => setShowModal(false)}
                        className="w-[730px] max-w-[730px]"
                    >
                        <SelectPermissions onClick={setPermissions} />
                    </Modal>
                }
            </>
        </FormWrapper>
    )
}

CreateRole.propTypes = {
    skip: PropTypes.func,
}